import {
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  GET_EMPLOYEE_INFO,
  SET_USER_MANUAL_DATA,
  UPDATE_USER_MANUAL_MODAL,
  SET_USER_MANUAL_FAIL,
  GET_ALL_USER_MANUAL,
  ERROR_USER_MANUAL_FAIL
} from "../actions/actionTypes"

const initialState = {
  loggedIn: false,
  userManualData: [],
  userModal: {},
  errorMsg: "",
  m_userData: [],
  usererrorMsg: "",
}

function UserManualRedux(state = initialState, action) {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...state,
        loggingIn: false
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true
      }
    case LOGIN_FAIL:
      return {
        loggedIn: false
      }
    case LOGOUT:
      return {
        loggingIn: false
      }
    case GET_EMPLOYEE_INFO:
      return {
        ...state
      }
    case SET_USER_MANUAL_DATA:
      return {
        ...state,
        userManualData: action.payload,
        errorMsg: ""
      }
    case UPDATE_USER_MANUAL_MODAL:
      // console.log("UPDATE_USER_MANUAL_MODAL", action)
      return {
        ...state,
        userModal: action.data
      }
    case SET_USER_MANUAL_FAIL:
      return {
        ...state,
        errorMsg: action.data
      }
    case GET_ALL_USER_MANUAL:
      return {
        ...state,
        userManualData: action.payload,
      }
    case ERROR_USER_MANUAL_FAIL:
      return {
        ...state,
        usererrorMsg: action.payload,
      }
    default:
      return state;
  }
}

export default UserManualRedux
